import axiosInstance from "../../core/axiosConfig.ts";

export class OrderService {

    cancelOrder = async (orderId: number) => {
        await axiosInstance.patch(
            `/order/cancel?orderId=${orderId}`
        );
    }

    confirmOrder = async (orderId: number, estimatedTime:string) => {
        console.log(estimatedTime)
        await axiosInstance.patch(
            `/order/confirm?orderId=${orderId}&estimatedTime=${estimatedTime}`
        );
    }

    markOrderAsReady = async (orderId: number) => {
        await axiosInstance.patch(
            `/order/ready-for-pickup?orderId=${orderId}`
        );
    }

    assingCourierManually = async (courierId: string, orderId: string | number) => {
        await axiosInstance.patch(
            `/order/update/assign-courier?courierId=${courierId}&orderId=${orderId}`
        );
    }

    // Completes an order Wolt carried when Wolt's own "delivered" never arrived.
    markWoltOrderDelivered = async (orderId: string | number) => {
        await axiosInstance.patch(`/order/wolt/mark-delivered?orderId=${orderId}`);
    }

    // Dine-in served / pickup collected (same endpoint): completes the order (DELIVERED).
    markOrderAsServed = async (orderId: string | number) => {
        await axiosInstance.patch(`/order/served?orderId=${orderId}`);
    }

    // Sends an accepted order to a delivery service (e.g. WOLT) from the board.
    handOver = async (orderId: string | number, provider: string) => {
        await axiosInstance.patch(`/order/delivery/hand-over?orderId=${orderId}&provider=${provider}`);
    }
}